import logo from '../../assets/images/logo/logo.png';

const appTextContentArabic = {
  backToHome: {
    link: '/',
    btnClass: 'btn btn-icon btn-primary',
    icon: 'arrow-left',
  },
  logo: {
    link: '#',
    imageSrc: logo,
    alt: 'Subul Contracting Logo',
  },
  title: 'التطبيق قريبا...',
  description: `ابدأ العمل مع شركة Subul Contracting التي يمكنها توفير كل شيء
  تحتاج إلى ضمان راحة منزلك وكفاءته.
  استمتع بأفضل حلول التدفئة والتبريد والتهوية.`,
  goBackHomeBtn: {
    link: '/',
    btnClass: 'btn btn-primary mt-4',
    iconClass: 'mdi mdi-backup-restore',
    text: 'ارجع الى البيت',
  },
};

export { appTextContentArabic }